import React from "react";
import { Users, Pencil, Trash2, Ban, Check, KeyRound } from "lucide-react";

const ROLE_COLORS = {
  familia: "bg-blue-100 text-blue-800", consultor: "bg-indigo-100 text-indigo-800",
  clinica: "bg-amber-100 text-amber-800", admin: "bg-purple-100 text-purple-800",
  profissional: "bg-emerald-100 text-emerald-800",
};

export const UsersTable = ({ users, onChangeRole, onEdit, onToggleBlock, onDelete, onResetPassword }) => (
  <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
    <div className="p-4 border-b border-slate-200 flex items-center gap-2">
      <Users className="w-5 h-5 text-slate-500" />
      <h2 className="font-display font-bold text-lg text-[#0B2B62]">Usuários ({users.length})</h2>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm min-w-[760px]">
        <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
          <tr>
            <th className="px-4 py-2.5 text-left">Nome</th>
            <th className="px-4 py-2.5 text-left">E-mail</th>
            <th className="px-4 py-2.5 text-left">Perfil</th>
            <th className="px-4 py-2.5 text-left">Criado</th>
            <th className="px-4 py-2.5 text-right">Ações</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {users.map((u) => (
            <tr key={u.id} data-testid={`admin-user-${u.id}`} className="hover:bg-slate-50">
              <td className="px-4 py-2.5 text-slate-800">{u.name}</td>
              <td className="px-4 py-2.5 text-slate-600">{u.email}</td>
              <td className="px-4 py-2.5">
                <select value={u.role} onChange={(e) => onChangeRole(u.id, e.target.value)}
                  data-testid={`admin-role-${u.id}`}
                  className={`text-xs font-semibold px-2 py-1 rounded-full border-0 outline-none ${ROLE_COLORS[u.role] || "bg-slate-100 text-slate-700"}`}>
                  <option value="familia">Família</option>
                  <option value="consultor">Consultor</option>
                  <option value="clinica">Unidade Parceira</option>
                  <option value="profissional">Profissional</option>
                  <option value="admin">Admin</option>
                </select>
              </td>
              <td className="px-4 py-2.5 text-xs text-slate-500">{u.created_at ? new Date(u.created_at).toLocaleDateString("pt-BR") : "—"}</td>
              <td className="px-4 py-2.5 text-right">
                <div className="inline-flex items-center gap-1">
                  <button data-testid={`admin-edit-${u.id}`} onClick={() => onEdit({ ...u })} className="text-slate-500 hover:text-[#0B2B62] p-1.5 rounded-md hover:bg-slate-100" title="Editar">
                    <Pencil className="w-4 h-4" />
                  </button>
                  {onResetPassword && u.role !== "familia" && (
                    <button data-testid={`admin-reset-pwd-${u.id}`} onClick={() => onResetPassword(u)} className="text-emerald-700 hover:text-emerald-800 p-1.5 rounded-md hover:bg-emerald-50" title="Gerar nova senha temporária">
                      <KeyRound className="w-4 h-4" />
                    </button>
                  )}
                  <button data-testid={`admin-block-${u.id}`} onClick={() => onToggleBlock(u)} className={`p-1.5 rounded-md ${u.blocked ? "text-green-600 hover:bg-green-50" : "text-amber-600 hover:bg-amber-50"}`}
                    title={u.blocked ? "Desbloquear" : "Bloquear"}>
                    {u.blocked ? <Check className="w-4 h-4" /> : <Ban className="w-4 h-4" />}
                  </button>
                  <button data-testid={`admin-del-${u.id}`} onClick={() => onDelete(u.id, u.email)} className="text-red-500 hover:text-red-700 p-1.5 rounded-md hover:bg-red-50" title="Excluir">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
                {u.blocked && <div className="text-[10px] text-red-600 font-semibold uppercase mt-1">Bloqueado</div>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default UsersTable;
